import { Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { HearingFilterResponse } from '../../../../types/search-hearing.type'
import { TableCellGroup } from './components/TableCellGroup'
import { StyledTableCell as TableHeadCell } from './styles'

type TableDataProps = {
  data: HearingFilterResponse[]
  isExcluded: boolean
  isFinalized: boolean
  onDelete: (hearingId?: number) => void
  onDownload: (hearingId?: number) => void
  onReactivate: (hearingId?: number) => void
}

export const TableData: React.FC<TableDataProps> = ({
  data,
  isExcluded,
  isFinalized,
  onDelete,
  onDownload,
  onReactivate,
}) => {
  const navigate = useNavigate()

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {isExcluded ? (
              <>
                <TableHeadCell>Nome do adolescente</TableHeadCell>
                <TableHeadCell>Data da exclusão</TableHeadCell>
                <TableHeadCell>Nome do responsável pela exclusão</TableHeadCell>
              </>
            ) : isFinalized ? (
              <>
                <TableHeadCell>Nome do adolescente</TableHeadCell>
                <TableHeadCell>N° CNJ</TableHeadCell>
                <TableHeadCell>Data da inclusão</TableHeadCell>
                <TableHeadCell>Nome do responsável pela inclusão</TableHeadCell>
              </>
            ) : (
              <>
                <TableHeadCell>Nome do adolescente</TableHeadCell>
                <TableHeadCell>Documento</TableHeadCell>
                <TableHeadCell>Data da inclusão</TableHeadCell>
                <TableHeadCell>Data de nascimento</TableHeadCell>
                <TableHeadCell>Nome do responsável pela inclusão</TableHeadCell>
              </>
            )}
            <TableHeadCell align='center' sx={{ width: '150px' }}>
              Ação
            </TableHeadCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => (
            <TableRow hover tabIndex={index} key={item.idOitiva}>
              <TableCellGroup
                data={item}
                isExcluded={isExcluded}
                isFinalized={isFinalized}
                navigate={navigate}
                onDelete={onDelete}
                onDownload={onDownload}
                onReactivate={onReactivate}
              />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
